import ApiService from "../../../common/api.service";
import { router } from "../../../router";
import { Message } from "element-ui";
import { mutationFormPromo } from './utils'
import _ from 'lodash'

export async function GetPromos({ commit }, option) {
  try {
    ApiService.init("heroku");
    commit("PROMOS_REQUEST");
    ApiService.setHeader();
    const _response = await ApiService.query("/v1/promo", option);
    commit("PROMOS_SUCCESS", _response);
  } catch (error) {
    commit("PROMOS_ERROR", { result: error.message });
  }
}

export async function CreatePromo({ commit }, form) {
  const tempForm = _.cloneDeep(form)
  try {
    ApiService.init("heroku");
    commit("CREATE_PROMO_REQUEST");
    ApiService.setHeader();
    const mutationFormPromoValue = await mutationFormPromo(tempForm)
    await ApiService.post("/v1/promo", mutationFormPromoValue); // perlu disesuaikan dengan relative url yang di-deploy
    commit("CREATE_PROMO_SUCCESS", mutationFormPromoValue);
    Message({
      message: "Create completed",
      type: "success"
    });
    router.go(-1);
  } catch (error) {
    commit("CREATE_PROMO_ERROR", { result: error.message });
  }
}

export async function GetPromo({ commit }, params) {
  try {
    const { promoType, id } = params;
    ApiService.init("heroku");
    commit("GET_PROMO_REQUEST");
    ApiService.setHeader();
    const _response = await ApiService.get(`/v1/promo/${promoType}/${id}`); // perlu disesuaikan dengan relative url yang di-deploy
    commit("GET_PROMO_SUCCESS", _response);
  } catch (error) {
    commit("GET_PROMO_ERROR", { result: error.message });
  }
}

export async function UpdatePromo({ commit }, form) {
  const tempForm = _.cloneDeep(form)
  try {
    ApiService.init("heroku");
    commit("EDIT_PROMO_REQUEST");
    ApiService.setHeader();
    const mutationFormPromoValue = await mutationFormPromo(tempForm)
    await ApiService.put("/v1/promo/main/" + mutationFormPromoValue._id, mutationFormPromoValue); // perlu disesuaikan dengan relative url yang di-deploy
    commit("EDIT_PROMO_SUCCESS", mutationFormPromoValue);
    Message({
      message: "Update completed",
      type: "success"
    });
    router.go(-1);
  } catch (error) {
    commit("EDIT_PROMO_ERROR", { result: error.message });
  }
}

export async function DeletePromo({ commit }, payload) {
  try {
    ApiService.init('heroku');
    commit("DELETE_PROMO_REQUEST");
    ApiService.setHeader();
    await ApiService.delete("/v1/promo", payload); // perlu disesuaikan dengan relative url yang di-deploy
    commit("DELETE_PROMO_SUCCESS", payload);
    Message({
      message: "Delete completed",
      type: "success"
    });
  } catch (error) {
    commit("DELETE_PROMO_ERROR", { result: error.message });
    Message({
      message: "Delete not success",
      type: "error"
    });
  }
}

export async function UpdateStatusPromo({ commit }, payload) {
  try {
    ApiService.init("heroku");
    commit("EDIT_PROMO_REQUEST");
    ApiService.setHeader();
    const _response = await ApiService.put("/v1/promo/main/" + payload.id, payload);
    commit("EDIT_PROMO_SUCCESS", _response);
    Message({
      message: "Update completed",
      type: "success"
    });
  } catch (error) {
    commit("EDIT_PROMO_ERROR", { result: error.message });
  }
}
